import React from 'react';

import './App.css';
import SlideshowContainer from './components/SlideshowContainer';

function App() {
  return (
    <React.StrictMode>
      <SlideshowContainer />
      <div className="card">
        <p>
          <code></code>
        </p>
      </div>
    </React.StrictMode>
  );
}

export default App;
